import { mergeDeepLeft } from 'ramda';
import getLocale from "../../locale/getLocale";
import getStoreLocatorBaseURL from "../../url/getStoreLocatorBaseURL";
import { DEFAULT_OPTIONS, OPTION_TYPES } from './constants';
import buildUrl from './helpers/buildUrl';
/**
 * Returns an absolute path to the correct endpoint depending on options and environment.
 * @param {string} endpoint - The specific endpoint.
 * @param {object} userOptions - An options object. See DEFAULT_OPTIONS in constants.ts.
 * @returns {string} An absolute path to the correct endpoint.
 */
const getApiUrl = (endpoint, userOptions = {}) => {
    let locale = '';
    let apiVersion = '';
    const isExternalUrlRegex = /^(?:[a-z]+:)?\/\//i;
    if (isExternalUrlRegex.test(endpoint))
        return endpoint;
    const options = mergeDeepLeft(userOptions, DEFAULT_OPTIONS);
    const query = options.query || '';
    if (options.use.locale)
        locale = options.customLocale || getLocale();
    if (options.use.apiVersion)
        apiVersion = `v${options.apiVersion}`;
    const trimmedEndpoint = endpoint.replace(/^\//, '');
    const dot = apiVersion ? '.' : '';
    const suffix = `${dot}${apiVersion}.json${query}`;
    switch (options.type) {
        case OPTION_TYPES.BASE:
            return buildUrl([locale, apiVersion, trimmedEndpoint]);
        case OPTION_TYPES.STORE_LOCATOR_RADIUS:
            return buildUrl([trimmedEndpoint]);
        case OPTION_TYPES.STORE_LOCATOR:
            return buildUrl([apiVersion, 'brand/hm', endpoint, locale, query], getStoreLocatorBaseURL());
        case OPTION_TYPES.ADOBE:
            return buildUrl([locale, `${trimmedEndpoint}${suffix}`]);
        default:
            // If we are not on Base (we are using ADOBE endpoints, atm (member/customer-service))
            return buildUrl([locale, trimmedEndpoint]);
    }
};
export default getApiUrl;
//# sourceMappingURL=getApiUrl.js.map